import React from 'react';

interface ThinkingBlockProps {
  content: string;
  isExpanded: boolean;
  onToggle: () => void;
}

const ThinkingBlock: React.FC<ThinkingBlockProps> = ({ content, isExpanded, onToggle }) => {
  const truncatedContent = content.length > 150 ? content.substring(0, 150) + '...' : content;

  return (
    <div
      className="thinking-block"
      style={{
        background: 'rgba(139, 92, 246, 0.05)',
        border: '1px dashed rgba(139, 92, 246, 0.3)',
        borderRadius: '8px',
        padding: '0.75rem',
        fontSize: '0.8rem',
        color: 'var(--text-secondary)',
      }}
    >
      <div
        className="thinking-header"
        onClick={onToggle}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          cursor: 'pointer',
          marginBottom: isExpanded ? '0.5rem' : 0,
        }}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#8b5cf6"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease',
          }}
        >
          <polyline points="9 18 15 12 9 6" />
        </svg>
        <span style={{ color: '#8b5cf6', fontWeight: 500 }}>Thinking</span>
        {!isExpanded && (
          <span style={{ fontStyle: 'italic', color: 'var(--text-tertiary)' }}>
            {truncatedContent}
          </span>
        )}
      </div>

      {isExpanded && (
        <div
          className="thinking-content"
          style={{
            whiteSpace: 'pre-wrap',
            lineHeight: '1.5',
            paddingLeft: '1.25rem',
            borderLeft: '2px solid rgba(139, 92, 246, 0.3)',
            marginLeft: '0.25rem',
          }}
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default ThinkingBlock;
